/**
 * Sentry — browser/client (App Router pattern para Next.js 13+).
 * Carregado pelo Next.js automaticamente em todas as páginas.
 * No-op se NEXT_PUBLIC_SENTRY_DSN não estiver setado.
 */
import * as Sentry from '@sentry/nextjs'

const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN

if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV,

    // Tracing — 100% em dev, 10% em prod
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,

    // Session Replay — 10% das sessões, 100% das que tiveram erro
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    // PII desativado por LGPD — usuário tem CPF, e-mail, dados pessoais
    sendDefaultPii: false,

    integrations: [
      Sentry.replayIntegration({
        // Mascara TODO conteúdo de texto e mídia por padrão (LGPD)
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],

    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      'Failed to fetch',
      'NetworkError when attempting to fetch resource',
      'Non-Error promise rejection captured',
    ],
  })
}

// Captura navegações do App Router como spans (tracing client-side)
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
